export default "__VITE_ASSET__j51K9OuY__"